// src/features/dataSlice.js
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { STATUS } from '../utils/status';
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';

// Helper function to convert Firestore Timestamp to Date
const convertTimestampToDate = (project) => {
    return {
        ...project,
        timeStamp: project.timeStamp.toDate().toISOString(),
    };
};

const initialState = {
    referanslardata: [],
    referanslarstatus: STATUS.IDLE,
    referanslarerror: null,
};

// Firestore'dan kullanıcıları almak için bir async thunk
export const fetchReferanslar = createAsyncThunk('referanslar/fetchReferanslar', async () => {
    const querySnapshot = await getDocs(collection(db, 'referanslar'));
    let projects = [];
    querySnapshot.forEach((doc) => {
        projects.push({ id: doc.id, ...convertTimestampToDate(doc.data()) });
    });
    return projects;
});


// Yeni bir kullanıcı oluşturmak için bir async thunk
export const addReferanslar = createAsyncThunk('referanslar/addReferanslar', async ({ newUser }) => {
    const userWithTimestamp = { ...newUser, timeStamp: serverTimestamp() };
    const docRef = await addDoc(collection(db, 'referanslar'), userWithTimestamp);
    const docSnapshot = await getDoc(docRef); // Change here
    return { id: docRef.id, ...convertTimestampToDate(docSnapshot.data()) };
});

// Kullanıcıyı güncellemek için bir async thunk
export const updateReferanslar = createAsyncThunk('referanslar/updateReferanslar', async ({ id, updatedData }) => {
    const userRef = doc(db, 'referanslar', id);
    await updateDoc(userRef, { ...updatedData, timeStamp: serverTimestamp() });
    const updatedSnapshot = await getDoc(userRef); // Change here
    return { id, ...convertTimestampToDate(updatedSnapshot.data()) };
});

// Kullanıcıyı silmek için bir async thunk
export const deleteReferanslar = createAsyncThunk('referanslar/deleteReferanslar', async (id) => {
    await deleteDoc(doc(db, 'referanslar', id));
    return id;
});


const referansSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchReferanslar.pending, (state) => {
                state.referanslarstatus = STATUS.LOADING;
            })
            .addCase(fetchReferanslar.fulfilled, (state, action) => {
                state.referanslarstatus = STATUS.SUCCESS;
                state.referanslardata = action.payload;
            })
            .addCase(fetchReferanslar.rejected, (state, action) => {
                state.referanslarstatus = STATUS.FAIL;
                state.referanslarerror = action.error.message;
            })
            .addCase(addReferanslar.pending, (state) => {
                state.referanslarstatus = STATUS.LOADING;
            })
            .addCase(addReferanslar.fulfilled, (state, action) => {
                state.referanslarstatus = STATUS.SUCCESS;
                state.referanslardata.push(action.payload);
            })
            .addCase(addReferanslar.rejected, (state, action) => {
                state.referanslarstatus = STATUS.FAIL;
                state.referanslarerror = action.error.message;
            })
            .addCase(updateReferanslar.pending, (state) => {
                state.referanslarstatus = STATUS.LOADING;
            })
            .addCase(updateReferanslar.fulfilled, (state, action) => {
                state.referanslarstatus = STATUS.SUCCESS;
                const index = state.referanslardata.findIndex((user) => user.id === action.payload.id);
                if (index !== -1) {
                    state.referanslardata[index] = action.payload;
                }
            })
            .addCase(updateReferanslar.rejected, (state, action) => {
                state.referanslarstatus = STATUS.FAIL;
                state.referanslarerror = action.error.message;
            })
            .addCase(deleteReferanslar.pending, (state) => {
                state.referanslarstatus = STATUS.LOADING;
            })
            .addCase(deleteReferanslar.fulfilled, (state, action) => {
                state.referanslarstatus = STATUS.SUCCESS;
                state.referanslardata = state.referanslardata.filter((user) => user.id !== action.payload);
            })
            .addCase(deleteReferanslar.rejected, (state, action) => {
                state.referanslarstatus = STATUS.FAIL;
                state.referanslarerror = action.error.message;
            });
    },
});

export default referansSlice.reducer;
